import { Directive, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ElasticSearchService } from '../shared/search-elasticsearch.service';
import { UtilsService } from '../shared/utils.service';
import { ContentService } from '../shared/content.service';

import { prebootComplete } from "angular2-universal";

@Directive({
  selector: '[content-specials]',
  exportAs: 'specials',
})
export class ContentSpecialsComponent implements OnInit {

  @Input() currentLanguage: string;
  public dbContents = [];

  constructor(private contentService: ContentService, private utils: UtilsService, private route: ActivatedRoute, private router: Router, private es: ElasticSearchService) {}

  ngOnInit(){
    this.contentService.getContents('special')
      .then(res => {
        this.dbContents = res;
        this.filterNonActive();
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof prebootComplete != 'undefined') {
          prebootComplete();
        }
      });
  }

  filterNonActive(){
    let filtered = [];
    for(let content of this.dbContents){
      if(content.active)
        filtered.push(content);
    }
    this.dbContents = filtered;
  }

  dbContentsLimited(limit: number): any[] {
    let limited = [];
    for (var i = 0; i < this.dbContents.length; i++) {
      limited.push(this.dbContents[i]);
      if(i==limit-1)
        break;
    }
    return limited;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-specials.component.ts